import { Component, inject } from '@angular/core';
import { PasButtonRoundColor, PasButtonRoundComponent } from '@porsche-aftersales/frontend-toolbox';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

import { createDeleteAttachmentAllowed } from '../../../../services/attachment/attachments-functions';
import { checkReadRightsForRecourseType } from '../../../../services/booking/recourse-booking-functions';
import { RecourseBookingStore } from '../../../../services/booking/recourse-booking-store';
import { BookingRoutingService } from '../../../../services/details-view-service/booking-routing.service';
import { UserRights } from '../../../../services/user-service/user-rights.enum';
import { UserService } from '../../../../services/user-service/user.service';
import { RecourseBookingModel } from '../../model/recourse-booking-model';

@Component({
  selector: 'app-delete-download-cell-renderer',
  templateUrl: './delete-download-cell-renderer.component.html',
  imports: [PasButtonRoundComponent],
})
export class DeleteDownloadCellRenderer implements ICellRendererAngularComp {
  private readonly recourseBookingStore = inject(RecourseBookingStore);
  private readonly userService = inject(UserService);
  private readonly bookingRoutingService = inject(BookingRoutingService);

  private params: any;
  private isNew = false;

  public agInit(params: ICellRendererParams): void {
    this.params = params;
    this.isNew = this.bookingRoutingService.isNewTabActive();
  }

  public refresh(params: any): boolean {
    this.params = params;
    return false;
  }

  public onDelete($event: any): void {
    if (this.params.onDelete instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data,
        // ...something
      };
      this.params.onDelete(params);
    }
  }

  public onDownload($event: any): void {
    if (this.params.onDownload instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data,
        // ...something
      };
      this.params.onDownload(params);
    }
  }

  public isDeletable(): boolean {
    if (this.isNew) {
      return true;
    } else if (this.bookingRoutingService.isViewTabActive()) {
      return false;
    }
    const recourseBooking: RecourseBookingModel = this.recourseBookingStore.selectedRecourseBooking;
    const rights: UserRights[] = this.userService.getRights();
    const hasRights: boolean = checkReadRightsForRecourseType(rights, recourseBooking.recourseTypeId);
    const isCreateDeleteAttachmentAllowed = createDeleteAttachmentAllowed(recourseBooking);
    return hasRights && isCreateDeleteAttachmentAllowed;
  }

  public isDownloadable(): boolean {
    return !this.isNew;
  }

  public readonly pasButtonRoundColor = PasButtonRoundColor;
}
